import { html, nothing } from '../application_element/element.js';
import PlotElement from '../plot_element/element.js';
import translations from './translations.js';
import style from './style.lit.css';

/**
 * A series or timeseries as columns. Drawn in CSS rather than SVG — the bars are
 * rectangles on a flex row, which stay crisp at any width without measuring the
 * element first.
 *
 * @prop values - Print each value above its bar ( boolean, default: false )
 *
 * @cssprop [--bar-radius: 3px] - Corner rounding on the bars.
 * @cssprop [--bar-max-width: 56px] - Cap, so a two-bucket chart is not two slabs.
 */
export default class BarChart extends PlotElement {
  static properties = {
    values: { type: Boolean },
  };

  static translations = translations;

  static styles = [PlotElement.styles, style];

  constructor() {
    super();
    this.values = false;
  }

  renderColumn(row, index) {
    const height = this.heightOf(row);

    // An empty bucket draws nothing. A stub bar would read as a small amount,
    // which is the opposite of what it means.
    return html`
      <div class="column" title=${this.descriptionOf(row)}>
        ${this.values
          ? html`<span class="value" style="bottom: ${height}%"
              >${this.valueOf(row)}</span
            >`
          : nothing}
        ${height > 0
          ? html`<span
              class="fill"
              style="height: ${height}%; background-color: ${this.colorOf(
                row,
                index
              )}"></span>`
          : nothing}
      </div>
    `;
  }

  render() {
    if (this.empty) return this.renderEmpty();

    return this.renderPlot(html`
      <div class="body columns">
        ${this.rows.map((row, index) => this.renderColumn(row, index))}
      </div>
    `);
  }
}

BarChart.extendTranslationsAs('xs-bar-chart');

customElements.get('xs-bar-chart') ||
  customElements.define('xs-bar-chart', BarChart);
